module.exports = __webpack_public_path__ + "img/ferry2_TC.50e54f74.jpg";